import { render, staticRenderFns } from "./ProgramForm.vue?vue&type=template&id=6385155a&scoped=true&lang=pug&"
import script from "./ProgramForm.vue?vue&type=script&lang=js&"
export * from "./ProgramForm.vue?vue&type=script&lang=js&"
import style0 from "./ProgramForm.vue?vue&type=style&index=0&id=6385155a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6385155a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VFlex,VLayout,VTextField})
